// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCBxanlQxv5Uibg-hGakgcLxylJqxj4mLA",
  authDomain: "organox.firebaseapp.com",
  projectId: "organox",
  storageBucket: "organox.firebasestorage.app",
  messagingSenderId: "113513090194",
  appId: "1:113513090194:web:af58aa11b917a5320eaa4b",
  measurementId: "G-W0FK7FM6NY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
